import React from "react";
import {useTranslation} from "react-i18next";
import {useUserSettingsDataContext} from "../../../../../../../providers/UserSettingsProvider";
import {formatLength} from "../../../../../../../utils/TextUtils";
import "../../../components/groupItemPresenter.scss";

interface Props {
	label: string;
	value: number;
	onPropsClick: () => void;
	onDelete: () => void;
	disabled?: boolean;
}

const WallHeightPointItem: React.FC<Props> = ({label, value, onPropsClick, onDelete, disabled}) => {
	const {t} = useTranslation();
	const {settings} = useUserSettingsDataContext();

	const handlePropsClick = () => !disabled && onPropsClick();
	const handleDelete = () => !disabled && onDelete();

	const handleKeyDown = (handler: () => void) => (e: React.KeyboardEvent) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			handler();
		}
	};

	const propsCls = [
		"group-item-presenter_props",
		!disabled && "is-clickable",
		disabled && "disabled",
	].filter(Boolean).join(" ");

	const actionsButtonCls = [
		"group-item-presenter_actions_button",
		disabled && "disabled",
	].filter(Boolean).join(" ");

	return (
		<div className="group-item-presenter">
			<div className="group-item-presenter_label">
				{`${t("editor.topViewWallArea.heightPointItemPrefix")} ${label}`}
			</div>
			<div
				className={propsCls}
				role="button"
				tabIndex={disabled ? -1 : 0}
				onClick={handlePropsClick}
				onKeyDown={handleKeyDown(handlePropsClick)}
			>
				{formatLength(value, settings?.measurementSystem)}
			</div>
			<div className="group-item-presenter_actions">
				<div
					className={actionsButtonCls}
					role="button"
					aria-label={t("editor.topViewWallArea.removeHeightForPoint", {label})}
					tabIndex={disabled ? -1 : 0}
					onClick={handleDelete}
					onKeyDown={handleKeyDown(handleDelete)}
				>
					&times;
				</div>
			</div>
		</div>
	);
};

export default WallHeightPointItem;
